module.exports = __webpack_public_path__ + "img/fix-order.676b6886.svg";